<template>
  <sui-table basic="very" celled padded class="device-table">
    <sui-table-body>
      <sui-table-row v-for="device in myDevices" :key="device.ID">
        <sui-table-cell :width="5">
          {{device.Name}} ({{device.ID}})
        </sui-table-cell>
        <sui-table-cell :width="6" class="plan">
          <template v-if="$store.getters.userID === device.OwnerID"></template>
          {{getSubscriptionStatus(device.ID)}}
          <template v-if="getSubscriptionStatus(device.ID).indexOf('active') > -1">
            <b>{{getSubscriptionEndPeriod(device.ID) | formatDate}}</b>
          </template>
          <template v-if="getSubscriptionStatus(device.ID) === 'incomplete'">
            - please re-enter payment details
          </template>
        </sui-table-cell>
        <sui-table-cell :width="6" >
          <!-- Non billable device -->
          <template v-if="device.NonBillable">
            non billable device
          </template>
          <template v-else>
            <!-- No payment details -->
            <template v-if="!billingCustomer || !billingCustomer.CardLast4">
              Please set payment details first
            </template>
            <template v-else>
              <!-- There is no plan -->
              <sui-button compact v-if="!getSubscription(device.ID)" icon="cart plus" basic color="pink" @click="subscribe(device)">Purchase plan</sui-button>
              <!-- There is an active plan -->
              <div v-if="getSubscriptionStatus(device.ID).indexOf('active') > -1" class="ui toggle checkbox">
                <input type="checkbox" :checked="getSubscription(device.ID).CancelAtPerioEnd === false" @change="autoSubscribtionChangeHandler(device)">
                <label>Renew Automatically</label>
              </div>          &nbsp;
              <!-- There was a failure during purchase -->
              <sui-button compact basic
                          v-if="getSubscription(device.ID) && getSubscriptionStatus(device.ID).indexOf('active') === -1"
                          icon="times" color="pink" @click="cancel(getSubscription(device.ID))">Cancel</sui-button>
              <sui-button compact basic
                          v-if="getSubscription(device.ID) && getSubscriptionStatus(device.ID).indexOf('active') === -1"
                          icon="redo alternate" color="pink" @click="retry(device)">Try again</sui-button>
            </template>
          </template>
        </sui-table-cell>
      </sui-table-row>
      <sui-table-row v-if="(data || []).length === 0">
        <sui-table-cell :single-line="true">No devices</sui-table-cell>
      </sui-table-row>
    </sui-table-body>

    <purchase-confirmation v-if="confirmPayment" @close="confirmPaymentCloseHandler" :device="confirmPaymentDevice"/>

  </sui-table>
</template>

<script>
  import PurchaseConfirmation from "./PurchaseConfirmation";
  export default {
    name: "DevicePlanTable",
    components: {PurchaseConfirmation},
    props: ["data", "billingCustomer"],
    data: function() {
      return {
        confirmPayment: false,
        confirmPaymentDevice: null,
      }
    },
    computed: {
      myDevices() {
        return (this.data || []).filter((device) => {
          if (device.OwnerID !== this.$store.getters.userID) return false;
          if (device.NonBillable === true) return false;
          return true;
        })
      },
    },
    methods: {
      async confirmPaymentCloseHandler(result) {
        this.confirmPayment = false
        if (result) {
          // Purchase has been confirmed
          await this.$store.dispatch('billing/subscribe', this.confirmPaymentDevice)
          if (this.$store.state.billing.subscribeResponse) {
            alert('Thank you for subscribing. Your SIM plan is now active')
            this.$store.dispatch('billing/getBilling')
          }
        }
        this.confirmPaymentDevice = null
      },
      async autoSubscribtionChangeHandler(device) {
        let subscription = this.getSubscription(device.ID)
        if (!subscription) return
        if (subscription.CancelAtPerioEnd === true) {
          this.enableAutoRenew(subscription)
        } else {
          this.disableAutoRenew(subscription)
        }
      },
      async subscribe(device) {
        this.confirmPayment = true;
        this.confirmPaymentDevice = device;
        return
        // await this.$store.dispatch('billing/subscribe', device)
        // if (this.$store.state.billing.subscribeResponse) {
        //   this.$store.dispatch('billing/getBilling')
        // }
      },

      async enableAutoRenew(subscription) {
        await this.$store.dispatch('billing/enableAutoRenew', subscription)
        if (this.$store.state.billing.enableAutoRenewResponse) {
          this.$store.dispatch('billing/getBilling')
        }
      },

      async disableAutoRenew(subscription) {
        await this.$store.dispatch('billing/disableAutoRenew', subscription)
        if (this.$store.state.billing.disableAutoRenewResponse) {
          this.$store.dispatch('billing/getBilling')
        }
      },

      async cancel(subscription) {
        await this.$store.dispatch('billing/cancelSubscription', subscription)
        if (this.$store.state.billing.cancelSubscribtionResponse) {
          this.$store.dispatch('billing/getBilling')
        }
      },

      async retry(device) {
        let subscription = this.getSubscription(device.ID)
        await this.$store.dispatch('billing/cancelSubscription', subscription)
        if (this.$store.state.billing.error) return
        await this.$store.dispatch('billing/subscribe', device)
        if (this.$store.state.billing.error) return
        this.$store.dispatch('billing/getBilling')
      },

      getSubscription(deviceID) {
        let subscriptionMap = ((this.$store.state.billing.getBillingResponse || {}).BillingCustomer || {}).SubscriptionMap
        if (!subscriptionMap) {
          return false
        }
        return subscriptionMap[deviceID]
      },
      getSubscriptionStatus(deviceID) {
        let subs = this.getSubscription(deviceID)
        if (!subs) return "no plan"
        if (subs.Status !== 'active') return subs.Status
        if (subs.CancelAtPerioEnd) return "active - no renewal, ends on"
        return "active - will renew automatically on"
      },
      getSubscriptionEndPeriod(deviceID) {
        let subs = this.getSubscription(deviceID)
        if (!subs) return null
        return subs.PeriodEnd
      },
    }
  }
</script>

<style scoped>
  .plan {
    text-transform: capitalize;
  }

</style>
